module.exports = __webpack_public_path__ + "05_short_brown.ab3f3fdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/05_short_brown.png
// module id = 2llq
// module chunks = 0